<template>
    <modal @close="$emit('close')">
        <p class="text-white font-bold text-xl top-font -mt-4" slot="header">Изменить данные об участии</p>

        <div class="pb-5 px-6 text-sm font-semibold text-main-text text-center">

            <p class="text-lg mt-4">Измените количество участников</p>
            <div class="w-full mt-4">
                <p v-if="teamValue!==null" class="flex w-full justify-center font-semibold text-main-text" id="one">
                    {{teamValue}}
                    {{declOfNum(teamValue, ['игрок', 'игрока', 'игроков'])}}</p>
                <input class="rage-selector px-8" v-model="teamValue" type="range" min="2" max="10" step="1">
                <div class="flex justify-between mx-3">
                    <p class="px-5 font-semibold text-additional-text">2</p>
                    <p class="px-5 font-semibold text-additional-text">10</p>
                </div>
            </div>

            <div class="flex flex-col content-start items-stretch pt-10">
                <button class="pay-button text-white bg-brand-light py-3 font-semibold" @click="closeReg">
                    Оплатить онлайн
                </button>
                <button class="mt-3 pay-button text-main-text bg-white py-3 underline" @click="closeReg">
                    Отменить запись в резерве
                </button>
            </div>


        </div>
    </modal>

</template>

<script>
import ModalMixin from '@/mixins/modals';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'Participate',
  components: { Modal },
  props: ['thanks', 'participate'],
  mixins: [ModalMixin],

  data() {
    return {
      teamValue: 2,
      show: true,
      teamSetup: '',
      loaded: false,
      vale: this.thanks,

    };
  },

  watch: {
    teamValue() {
      return this.teamValue;
    },

    count() {
      if (this.teamValue === 1 || 5 || 6 || 7 || 8 || 9 || 10) {
        this.count = 'игроков';
      } else {
        this.count = 'игрока';
      }
    },

    teamSetup() {
      return this.teamSetup;
    },
  },

  created() {
    this.loaded = true;
  },
  methods: {
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    closeReg() {
      this.$emit('thanks');
      this.vale = !this.vale;
    },
  },
};

</script>

<style scoped>


    button {
        width: 100%;
        border-radius: 28px;
        border: 1px solid rgba(151, 151, 151, 0);
        background-color: #bd006c;
        outline: none;
    }


    input[type=range] {
        -webkit-appearance: none;
        margin: 18px 0;
        width: 100%;
    }

    input[type=range]:focus {
        outline: none;
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        animate: 0.2s;
        background: #550045;
    }

    input[type=range]::-webkit-slider-thumb {
        box-shadow: 1px 1px 1px #bd006c, 0px 0px 1px #bd006c;
        border: 1px solid #bd006c;
        height: 20px;
        width: 20px;
        border-radius: 10px;
        background: #bd006c;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -9px;
        margin-bottom: -9px;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #550045;
    }

    input[type=range]::-moz-range-track {
        width: 100%;
        height: 1.4px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        background: #550045;
        border-radius: 1.3px;
        border: 0.2px solid #550045;
    }

    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        border: 1px solid #550045;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #550045;
        cursor: pointer;
    }

    input[type=range]::-ms-track {
        width: 100%;
        height: 1.4px;
        cursor: pointer;
        animate: 0.2s;
        background: transparent;
        border-color: transparent;
        border-width: 16px 0;
        color: transparent;
    }

    input[type=range]::-ms-fill-lower {
        background: #550045;
        border: 0.2px solid #550045;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
    }

    input[type=range]::-ms-fill-upper {
        background: #550045;
        border: 0.2px solid #550045;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
    }

    input[type=range]::-ms-thumb {
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        border: 1px solid #550045;
        height: 20px;
        width: 20px;
        border-radius: 3px;
        background: #550045;
        cursor: pointer;
    }

    input[type=range]:focus::-ms-fill-lower {
        background: #550045;
    }

    input[type=range]:focus::-ms-fill-upper {
        background: #550045;
    }


</style>
